import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=6b0bf0ce&scoped=true"
import script from "./create-order.vue?vue&type=script&lang=js"
export * from "./create-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bf0ce",
  null
  
)

export default component.exports